import React from 'react';

const FitResultDisplay = ({ response }) => {
  if (!response) return null;

  const { fits, message, recommendation, tilt_angle, stair_angle } = response;

  const difficulty =
    tilt_angle < 20 ? "Easy"
    : tilt_angle < 45 ? "Moderate"
    : "Hard";

  return (
    <div
      style={{
        marginTop: "2rem",
        background: fits ? "#e6f4ea" : "#ffeaea",
        border: `1px solid ${fits ? "#3c763d" : "#a94442"}`,
        padding: "1rem",
        borderRadius: "4px",
      }}
    >
      <h3 style={{ marginTop: 0 }}>{fits ? "✅ It Fits!" : "❌ Does Not Fit"}</h3>
      <p>{message}</p>
      {recommendation && (
        <p>
          <strong>Recommendation:</strong> {recommendation}
        </p>
      )}

      {typeof tilt_angle === "number" && (
        <p>
          <strong>Tilt Angle Required:</strong> {tilt_angle.toFixed(1)}°
          {" "}- <em>{difficulty}</em>
        </p>
      )}

      {typeof stair_angle === "number" && (
        <p>
          <strong>Staircase Slope Angle:</strong> {stair_angle.toFixed(1)}°
        </p>
      )}
    </div>
  );
};

export default FitResultDisplay;
